import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProofreaderOverlayComponent } from './proofreader-overlay.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ProofreaderOverlayComponent
  ],
  exports: [
    ProofreaderOverlayComponent
  ]
})
export class ProofreaderModule { }
